import axios from 'axios';

export const state = {
  secondaryMarketOrders: [],
  pagination: {},
  loading: false,
};

export const mutations = {
  setSecondaryMarketOrders(context, secondaryMarketOrders) {
    context.secondaryMarketOrders = secondaryMarketOrders;
    context.loading = false;
  },

  setPagination(context, pagination) {
    context.pagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getSecondaryMarketOrders({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const secondaryMarketOrders = await axios.get(`${window.BASE_API.BAADER}/secondary-market-orders?${query}`, options)
        .then(response => response.data);

      commit('setSecondaryMarketOrders', secondaryMarketOrders.data);
      commit('setPagination', secondaryMarketOrders.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const secondaryMarketOrdersStore = {
  state,
  mutations,
  actions,
};

export default secondaryMarketOrdersStore;



// WEBPACK FOOTER //
// ./src/store/baader/secondaryMarketOrdersStore.js